import {
  GET_JOB_FEEDBACK_REQUEST,
  GET_JOB_FEEDBACK_SUCCESS,
  GET_JOB_FEEDBACK_FAILURE,
} from "../../actionTypes";

export const getJobFeedbackRequest = (data) => ({
  type: GET_JOB_FEEDBACK_REQUEST,
  payload: data,
});

export const getJobFeedbackSuccess = (data) => ({
  type: GET_JOB_FEEDBACK_SUCCESS,
  payload: data,
});

export const getJobFeedbackFailure = (error) => ({
  type: GET_JOB_FEEDBACK_FAILURE,
  payload: error,
});


